import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getActiveExperimentsIds, getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlowForACQ151 } from '../../experiments/acq151/ACQ151Utils';
import { getIsExistingUserSession } from '../../store/app/selectors';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
export const BranchACQ151 = {
  name: 'BranchACQ151',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0151, [ExperimentParameterGroup.Variant_A]) && getActiveExperimentsIds(state).includes(ExperimentKeys.ACQ0151);
  },
  rebuildFlow: (flow, state, dispatch) => {
    return dispatch(setFlowForACQ151({
      isPreVerificationExistingUserSession: getIsExistingUserSession(state) && isPreVerification()
    }));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};